import {  FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM, RECEIVE_WORK_ORDERS_STOCKER_INBOUND_ITEM, FAILED_WORK_ORDERS_STOCKER_INBOUND_ITEM,
            FETCH_WORK_ORDERS_STOCKER_OUTBOUND_ITEM, RECEIVE_WORK_ORDERS_STOCKER_OUTBOUND_ITEM, FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM } from '../actions/aTransporter-WoStocker'

function getUniqueDeliveryItemSet(boundsData){
    boundsData.map((data, index) => {
        let filterByItemIdAndQty = boundsData.filter(bou => 
            bou.id === data.id
        )
        if(filterByItemIdAndQty.length > 1)
            boundsData.splice(index, filterByItemIdAndQty.length-1)
        return null
    })
    return boundsData
}

const defaultWoInbound = {
    woInboundData: null,
    woInboundSelect: [],
    success: true,
    inProgress: false,
}

export function woInboundItemDetail(state = defaultWoInbound, action){
    switch (action.type) {
        case FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM:
            return ({woInboundData: [], success: true,woInboundSelect: [], inProgress: true})
        case RECEIVE_WORK_ORDERS_STOCKER_INBOUND_ITEM:
            let inboundItemObj = action.payload
            Object.keys(inboundItemObj).map(key => {
                inboundItemObj[key] = getUniqueDeliveryItemSet(inboundItemObj[key])
                return null
                })
            return Object.assign({}, state, {woInboundData: action.payload, success: true,
                                            woInboundSelect: [], inProgress: false})
        case FAILED_WORK_ORDERS_STOCKER_INBOUND_ITEM:
            return ({woInboundData: [], success: false,woInboundSelect: [], inProgress: false})
        default:
            return state
    }
}

const defaultWoOutbound = {
        woOutboundData: null,
        woOutboundSelect: [],
        success: true,
        inProgress: false,
    }
    
    export function woOtuboundItemDetail(state = defaultWoOutbound, action){
        switch (action.type) {
            case FETCH_WORK_ORDERS_STOCKER_OUTBOUND_ITEM:
                return ({woOutboundData: [], success: true, woOutboundSelect: [], inProgress: true})
            case RECEIVE_WORK_ORDERS_STOCKER_OUTBOUND_ITEM:
            let outboundItemObj = action.payload
            Object.keys(outboundItemObj).map(key => {
                outboundItemObj[key] = getUniqueDeliveryItemSet(outboundItemObj[key])
                return null
                })
                return Object.assign({}, state, {woOutboundData: action.payload, success: true, 
                                                    woOutboundSelect: [], inProgress: false})
            case FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM:
                return ({woOutboundData: [], success: false, woOutboundSelect: [], inProgress: false})
            default:
                return state
        }
    }



// WEBPACK FOOTER //
// ./src/redux/reducers/redTransporter-WoStocker.jsx